export const ALL_COUNTRIES = [
	{ label: 'countries.AF', value: 'AF' },
	{ label: 'countries.AX', value: 'AX' },
	{ label: 'countries.AL', value: 'AL' },
	{ label: 'countries.DZ', value: 'DZ' },
	{ label: 'countries.AS', value: 'AS' },
	{ label: 'countries.AD', value: 'AD' },
	{ label: 'countries.AO', value: 'AO' },
	{ label: 'countries.AI', value: 'AI' },
	{ label: 'countries.AQ', value: 'AQ' },
	{ label: 'countries.AG', value: 'AG' },
	{ label: 'countries.AR', value: 'AR' },
	{ label: 'countries.AM', value: 'AM' },
	{ label: 'countries.AW', value: 'AW' },
	{ label: 'countries.AU', value: 'AU' },
	{ label: 'countries.AT', value: 'AT' },
	{ label: 'countries.AZ', value: 'AZ' },
	{ label: 'countries.BS', value: 'BS' },
	{ label: 'countries.BH', value: 'BH' },
	{ label: 'countries.BD', value: 'BD' },
	{ label: 'countries.BB', value: 'BB' },
	{ label: 'countries.BY', value: 'BY' },
	{ label: 'countries.BE', value: 'BE' },
	{ label: 'countries.BZ', value: 'BZ' },
	{ label: 'countries.BJ', value: 'BJ' },
	{ label: 'countries.BM', value: 'BM' },
	{ label: 'countries.BT', value: 'BT' },
	{ label: 'countries.BO', value: 'BO' },
	{ label: 'countries.BA', value: 'BA' },
	{ label: 'countries.BW', value: 'BW' },
	{ label: 'countries.BV', value: 'BV' },
	{ label: 'countries.BR', value: 'BR' },
	{ label: 'countries.IO', value: 'IO' },
	{ label: 'countries.BN', value: 'BN' },
	{ label: 'countries.BG', value: 'BG' },
	{ label: 'countries.BF', value: 'BF' },
	{ label: 'countries.BI', value: 'BI' },
	{ label: 'countries.KH', value: 'KH' },
	{ label: 'countries.CM', value: 'CM' },
	{ label: 'countries.CA', value: 'CA' },
	{ label: 'countries.CV', value: 'CV' },
	{ label: 'countries.KY', value: 'KY' },
	{ label: 'countries.CF', value: 'CF' },
	{ label: 'countries.TD', value: 'TD' },
	{ label: 'countries.CL', value: 'CL' },
	{ label: 'countries.CN', value: 'CN' },
	{ label: 'countries.CX', value: 'CX' },
	{ label: 'countries.CC', value: 'CC' },
	{ label: 'countries.CO', value: 'CO' },
	{ label: 'countries.KM', value: 'KM' },
	{ label: 'countries.CG', value: 'CG' },
	{ label: 'countries.CD', value: 'CD' },
	{ label: 'countries.CK', value: 'CK' },
	{ label: 'countries.CR', value: 'CR' },
	{ label: 'countries.CI', value: 'CI' },
	{ label: 'countries.HR', value: 'HR' },
	{ label: 'countries.CU', value: 'CU' },
	{ label: 'countries.CY', value: 'CY' },
	{ label: 'countries.CZ', value: 'CZ' },
	{ label: 'countries.DK', value: 'DK' },
	{ label: 'countries.DJ', value: 'DJ' },
	{ label: 'countries.DM', value: 'DM' },
	{ label: 'countries.DO', value: 'DO' },
	{ label: 'countries.EC', value: 'EC' },
	{ label: 'countries.EG', value: 'EG' },
	{ label: 'countries.SV', value: 'SV' },
	{ label: 'countries.GQ', value: 'GQ' },
	{ label: 'countries.ER', value: 'ER' },
	{ label: 'countries.EE', value: 'EE' },
	{ label: 'countries.ET', value: 'ET' },
	{ label: 'countries.FK', value: 'FK' },
	{ label: 'countries.FO', value: 'FO' },
	{ label: 'countries.FJ', value: 'FJ' },
	{ label: 'countries.FI', value: 'FI' },
	{ label: 'countries.FR', value: 'FR' },
	{ label: 'countries.GF', value: 'GF' },
	{ label: 'countries.PF', value: 'PF' },
	{ label: 'countries.TF', value: 'TF' },
	{ label: 'countries.GA', value: 'GA' },
	{ label: 'countries.GM', value: 'GM' },
	{ label: 'countries.GE', value: 'GE' },
	{ label: 'countries.DE', value: 'DE' },
	{ label: 'countries.GH', value: 'GH' },
	{ label: 'countries.GI', value: 'GI' },
	{ label: 'countries.GR', value: 'GR' },
	{ label: 'countries.GL', value: 'GL' },
	{ label: 'countries.GD', value: 'GD' },
	{ label: 'countries.GP', value: 'GP' },
	{ label: 'countries.GU', value: 'GU' },
	{ label: 'countries.GT', value: 'GT' },
	{ label: 'countries.GG', value: 'GG' },
	{ label: 'countries.GN', value: 'GN' },
	{ label: 'countries.GW', value: 'GW' },
	{ label: 'countries.GY', value: 'GY' },
	{ label: 'countries.HT', value: 'HT' },
	{ label: 'countries.HM', value: 'HM' },
	{ label: 'countries.VA', value: 'VA' },
	{ label: 'countries.HN', value: 'HN' },
	{ label: 'countries.HK', value: 'HK' },
	{ label: 'countries.HU', value: 'HU' },
	{ label: 'countries.IS', value: 'IS' },
	{ label: 'countries.IN', value: 'IN' },
	{ label: 'countries.ID', value: 'ID' },
	{ label: 'countries.IR', value: 'IR' },
	{ label: 'countries.IQ', value: 'IQ' },
	{ label: 'countries.IE', value: 'IE' },
	{ label: 'countries.IM', value: 'IM' },
	{ label: 'countries.IL', value: 'IL' },
	{ label: 'countries.IT', value: 'IT' },
	{ label: 'countries.JM', value: 'JM' },
	{ label: 'countries.JP', value: 'JP' },
	{ label: 'countries.JE', value: 'JE' },
	{ label: 'countries.JO', value: 'JO' },
	{ label: 'countries.KZ', value: 'KZ' },
	{ label: 'countries.KE', value: 'KE' },
	{ label: 'countries.KI', value: 'KI' },
	{ label: 'countries.KP', value: 'KP' },
	{ label: 'countries.KR', value: 'KR' },
	{ label: 'countries.KW', value: 'KW' },
	{ label: 'countries.KG', value: 'KG' },
	{ label: 'countries.LA', value: 'LA' },
	{ label: 'countries.LV', value: 'LV' },
	{ label: 'countries.LB', value: 'LB' },
	{ label: 'countries.LS', value: 'LS' },
	{ label: 'countries.LR', value: 'LR' },
	{ label: 'countries.LY', value: 'LY' },
	{ label: 'countries.LI', value: 'LI' },
	{ label: 'countries.LT', value: 'LT' },
	{ label: 'countries.LU', value: 'LU' },
	{ label: 'countries.MO', value: 'MO' },
	{ label: 'countries.MK', value: 'MK' },
	{ label: 'countries.MG', value: 'MG' },
	{ label: 'countries.MW', value: 'MW' },
	{ label: 'countries.MY', value: 'MY' },
	{ label: 'countries.MV', value: 'MV' },
	{ label: 'countries.ML', value: 'ML' },
	{ label: 'countries.MT', value: 'MT' },
	{ label: 'countries.MH', value: 'MH' },
	{ label: 'countries.MQ', value: 'MQ' },
	{ label: 'countries.MR', value: 'MR' },
	{ label: 'countries.MU', value: 'MU' },
	{ label: 'countries.YT', value: 'YT' },
	{ label: 'countries.MX', value: 'MX' },
	{ label: 'countries.FM', value: 'FM' },
	{ label: 'countries.MD', value: 'MD' },
	{ label: 'countries.MC', value: 'MC' },
	{ label: 'countries.MN', value: 'MN' },
	{ label: 'countries.MS', value: 'MS' },
	{ label: 'countries.MA', value: 'MA' },
	{ label: 'countries.MZ', value: 'MZ' },
	{ label: 'countries.MM', value: 'MM' },
	{ label: 'countries.NA', value: 'NA' },
	{ label: 'countries.NR', value: 'NR' },
	{ label: 'countries.NP', value: 'NP' },
	{ label: 'countries.NL', value: 'NL' },
	{ label: 'countries.AN', value: 'AN' },
	{ label: 'countries.NC', value: 'NC' },
	{ label: 'countries.NZ', value: 'NZ' },
	{ label: 'countries.NI', value: 'NI' },
	{ label: 'countries.NE', value: 'NE' },
	{ label: 'countries.NG', value: 'NG' },
	{ label: 'countries.NU', value: 'NU' },
	{ label: 'countries.NF', value: 'NF' },
	{ label: 'countries.MP', value: 'MP' },
	{ label: 'countries.NO', value: 'NO' },
	{ label: 'countries.OM', value: 'OM' },
	{ label: 'countries.PK', value: 'PK' },
	{ label: 'countries.PW', value: 'PW' },
	{ label: 'countries.PS', value: 'PS' },
	{ label: 'countries.PA', value: 'PA' },
	{ label: 'countries.PG', value: 'PG' },
	{ label: 'countries.PY', value: 'PY' },
	{ label: 'countries.PE', value: 'PE' },
	{ label: 'countries.PH', value: 'PH' },
	{ label: 'countries.PN', value: 'PN' },
	{ label: 'countries.PL', value: 'PL' },
	{ label: 'countries.PT', value: 'PT' },
	{ label: 'countries.PR', value: 'PR' },
	{ label: 'countries.QA', value: 'QA' },
	{ label: 'countries.RE', value: 'RE' },
	{ label: 'countries.RO', value: 'RO' },
	{ label: 'countries.RU', value: 'RU' },
	{ label: 'countries.RW', value: 'RW' },
	{ label: 'countries.SA', value: 'SA' },
	{ label: 'countries.SN', value: 'SN' },
	{ label: 'countries.SC', value: 'SC' },
	{ label: 'countries.SL', value: 'SL' },
	{ label: 'countries.SG', value: 'SG' },
	{ label: 'countries.SX', value: 'SX' },
	{ label: 'countries.SK', value: 'SK' },
	{ label: 'countries.SI', value: 'SI' },
	{ label: 'countries.SB', value: 'SB' },
	{ label: 'countries.SO', value: 'SO' },
	{ label: 'countries.ZA', value: 'ZA' },
	{ label: 'countries.GS', value: 'GS' },
	{ label: 'countries.ES', value: 'ES' },
	{ label: 'countries.LK', value: 'LK' },
	{ label: 'countries.SD', value: 'SD' },
	{ label: 'countries.SR', value: 'SR' },
	{ label: 'countries.SJ', value: 'SJ' },
	{ label: 'countries.SE', value: 'SE' },
	{ label: 'countries.SY', value: 'SY' },
	{ label: 'countries.TW', value: 'TW' },
	{ label: 'countries.TJ', value: 'TJ' },
	{ label: 'countries.TZ', value: 'TZ' },
	{ label: 'countries.TH', value: 'TH' },
	{ label: 'countries.TG', value: 'TG' },
	{ label: 'countries.TK', value: 'TK' },
	{ label: 'countries.TO', value: 'TO' },
	{ label: 'countries.TR', value: 'TR' },
	{ label: 'countries.TT', value: 'TT' },
	{ label: 'countries.TN', value: 'TN' },
	{ label: 'countries.TM', value: 'TM' },
	{ label: 'countries.TC', value: 'TC' },
	{ label: 'countries.TV', value: 'TV' },
	{ label: 'countries.UG', value: 'UG' },
	{ label: 'countries.UK', value: 'UK' },
	{ label: 'countries.UA', value: 'UA' },
	{ label: 'countries.AE', value: 'AE' },
	{ label: 'countries.US', value: 'US' },
	{ label: 'countries.UM', value: 'UM' },
	{ label: 'countries.UY', value: 'UY' },
	{ label: 'countries.UZ', value: 'UZ' },
	{ label: 'countries.VU', value: 'VU' },
	{ label: 'countries.VE', value: 'VE' },
	{ label: 'countries.VN', value: 'VN' },
	{ label: 'countries.WF', value: 'WF' },
	{ label: 'countries.YE', value: 'YE' },
	{ label: 'countries.ZM', value: 'ZM' },
	{ label: 'countries.ZW', value: 'ZW' },
];
